import KeyTrapDefault from './KeyTrap';

export default KeyTrapDefault;



// WEBPACK FOOTER //
// ./src/client/Components/KeyTrap/index.js